<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
console.log('00000000')
export default {
  
  name: 'app',
  mounted () {
    const script = document.createElement('script')
    script.src = 'https://v1.cnzz.com/z_stat.php?id=1279314124&web_id=1279314124'
    script.language = 'JavaScript'
    document.body.appendChild(script)
    console.log('友盟统计',window._czc)
  },
  
  watch: {
    '$route' () {
      if (window._czc) {
        let location = window.location
        let contentUrl = location.pathname + location.hash
        let refererUrl = '/' 
        window._czc.push(['_trackPageview', contentUrl, refererUrl])
      }
    }
  }
}
</script>
<style lang="scss">

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-width: 1200px;
  height:100vh;
}
</style>
